export default {
  emails: 'launchEmails'
};
